// extracted by mini-css-extract-plugin
module.exports = {"label":"e_st","disc":"e_tt","glyph":"e_ut","labelButton":"e_vt","tip":"e_wt","labelOpen":"e_xt"};